import { searchUsers, transferSuperAdmin } from 'actions/profileNew';
import { AutoComplete, Modal } from 'antd';
import { Button } from 'components/Button';
import SuccessModal from "./successModal";

import { InputSearch } from 'components/customInputs';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { LabelDiv } from './detailFields';
import './styles.css';

const TransferOwnershipModal = ({visible, handleClose, user, searchUsers, searchedUsers, transferSuperAdmin, setShowTransferModal}) => {
    const [search, setSearch] = useState('');
    const [searchLoading, setSearchLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [updatePrimaryContact, setUpdatePrimaryContact] = useState(false);
    const [buttonLoader, updateButtonLoader] = useState(false);
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [open, setOpen] = useState(false);
    const autoCompleteRef = React.useRef(null);

    const history = useHistory();
    console.log({selectedUser});

    const scrollToTop = () => {
        setTimeout(() => {
            const listHolder = document.querySelector('.transfer-dropdown .rc-virtual-list-holder');
            if (listHolder) {
                listHolder.scrollTop = 0;
            }
        }, 100);
    };

    useEffect(() => {
        if (visible) {
            setSearchLoading(true);
            setSearch('');
            setSelectedUser(null);
            setOpen(false);
            searchUsers('', () => setSearchLoading(false));
        }
    }, [visible]);

    useEffect(() => {
        if (open) {
            scrollToTop();
        }
    }, [searchedUsers, open]);

    const handleSuccessCallback = () => {
        setSuccessModalVisible(true);
      };
    

    const handleConfirmClick = () => {
        updateButtonLoader(true);
        const params = {
            userId: selectedUser?.id,
            updatePrimaryContact
        }
        transferSuperAdmin(params, () => updateButtonLoader(false), ()=>{/*setSuccessModalVisible(true);*/setShowTransferModal(false)}, history)
    }

    return (
        <Modal
            visible={visible}
            className="modal-round-corner"
            centered
            header={null}
            footer={null}
            onCancel={handleClose}
            width={900}
        >
            <div 
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "25px",
                }}
            >   
                <div
                    style={{ fontSize: "18px", fontWeight: 600 }}
                >
                    Transfer ownership
                </div>
                <div style={{textAlign: 'center', color:"#636363", width: "80%"}}>
                     We regret that you will no longer continue as the Super Admin of {user.org.name}! Before proceeding, please note that ownership can only be transferred to an existing user (Teacher/Data Operator/Operations) who is already added in User Management.
                </div>
                <div style={{width: "80%"}} className="m-t-20">
                    <LabelDiv>
                        User name
                    </LabelDiv>
                    <AutoComplete
                        ref={autoCompleteRef}
                        open={open}
                        onDropdownVisibleChange={(visible) => setOpen(visible)}
                        dropdownClassName="transfer-dropdown"
                        value={search}
                        onChange={(value, obj) => {
                            const val = value || '';
                            setSearch(val);
                            setSelectedUser(null);
                            if (val === '') {
                                setSearchLoading(true);
                                searchUsers('', () => setSearchLoading(false));
                            }
                        }}
                        options={searchedUsers}
                        style={{border:'none', width:'100%', fontSize:16, fontWeight:600}}
                        loading={searchLoading}
                        allowClear={true}
                        onClear={() => {
                            setSearch('');
                            setSelectedUser(null);
                            setSearchLoading(true);
                            searchUsers('', () => setSearchLoading(false));
                            setTimeout(() => {
                                setOpen(true);
                                if (autoCompleteRef.current) {
                                    autoCompleteRef.current.focus();
                                }
                            }, 100);
                        }}
                        onFocus={() => {
                            setSearchLoading(true);
                            searchUsers(search, () => setSearchLoading(false));
                        }}
                        onSelect={(value, obj) => {
                            setSelectedUser(obj);
                            setOpen(false);
                        }}
                        onSearch={(query) => {
                            setSearchLoading(true);
                            searchUsers(query, () => setSearchLoading(false))
                        }}
                        notFoundContent={searchLoading ? "Loading..." : "User not found"}
                    />
                </div>
                <Button type="primary" 
                    style={{marginTop: 100}} loading={buttonLoader}
                    onClick={() => {handleConfirmClick()}}
                    disabled={!selectedUser}
                >CONFIRM TRANSFER</Button>
            </div>
            {/* <SuccessModal
            isModalVisible={successModalVisible}
            handleOk={handleConfirmClick}
            handleCancel={handleConfirmClick}
            /> */}
           
        </Modal>
    );
}


const mapStateToProps = (state) => { 
    const {user} = state.session
    const {searchedUsers} = state.profileNew;
    return {
        user,
        searchedUsers
    }
}

const mapDispatchToProps = (dispatch) => ({
    searchUsers: (search, callback) => dispatch(searchUsers(search, callback)),
    transferSuperAdmin: (params, callback, successCallback, history) => dispatch(transferSuperAdmin(params, callback, successCallback, history))
})

export default connect(mapStateToProps, mapDispatchToProps)(TransferOwnershipModal);
